import { lazy } from 'react';

const LoginView = lazy(() => import('./views/login/login'));

const HomeView = lazy(() => import('./views/home/home'));

const ProfileView = lazy(() => import('./views/profile/profile'));
const ProfileManagementView = lazy(() => import('./views/profile/management'));

const DatasetsView = lazy(() => import('./views/datasets/datasets'));
const DataPickerView = lazy(() => import('./views/datasets/add/add'));
const DataEditView = lazy(() => import('./views/datasets/edit'));
const DataReadonlyView = lazy(() => import('./views/datasets/readonly'));
const DataEnrichmentView = lazy(
  () => import('./views/datasets/enrichment/add')
);
const DataEnrichmentEditView = lazy(
  () => import('./views/datasets/enrichment/edit')
);

const MapsView = lazy(() => import('./views/maps/maps'));
const MapEditView = lazy(() => import('./views/maps/edit'));
const FinalMapView = lazy(() => import('./views/final-map/final-map'));

const ServicesView = lazy(() => import('./views/services/services'));
const ServiceAddView = lazy(() => import('./views/services/add'));
const ServiceEditView = lazy(() => import('./views/services/edit'));
const AddWidgetView = lazy(() => import('./views/services/add-widget'));
const AddNewService = lazy(() => import('./views/services/add-new'));

export interface RouteInt {
  path: string;
  exact?: boolean;
  name: string;
  component: any;
}

const routes: { [key: string]: RouteInt[] } = {
  main: [
    { path: '/', exact: true, name: 'Main', component: HomeView },
    {
      path: '/maps',
      exact: true,
      name: 'Maps',
      component: MapsView,
    },
    {
      path: '/maps/edit',
      exact: true,
      name: 'Edit',
      component: MapEditView,
    },
    {
      path: '/datasets',
      exact: true,
      name: 'Datasets',
      component: DatasetsView,
    },
    {
      path: '/datasets/add',
      exact: true,
      name: 'DataPickerView',
      component: DataPickerView,
    },
    {
      path: '/datasets/edit',
      exact: true,
      name: 'DataEditView',
      component: DataEditView,
    },
    {
      path: '/datasets/view',
      exact: true,
      name: 'DataReadonlyView',
      component: DataReadonlyView,
    },
    {
      path: '/datasets/services/add',
      exact: true,
      name: 'ServiceAddView',
      component: ServiceAddView,
    },
    {
      path: '/datasets/enrichment/add',
      exact: true,
      name: 'DataEnrichmentView',
      component: DataEnrichmentView,
    },
    {
      path: '/datasets/enrichment/edit',
      exact: true,
      name: 'DataEnrichmentEditView',
      component: DataEnrichmentEditView,
    },
    {
      path: '/services',
      exact: true,
      name: 'Services',
      component: ServicesView,
    },
    {
      path: '/services/add',
      exact: true,
      name: 'AddNewService',
      component: AddNewService,
    },
    {
      path: '/services/edit',
      exact: true,
      name: 'ServiceEditView',
      component: ServiceEditView,
    },
    {
      path: '/widgets/add',
      exact: true,
      name: 'AddWidgetView',
      component: AddWidgetView,
    },
  ],
  login: [
    {
      path: '/login',
      exact: true,
      name: 'Login',
      component: LoginView,
    },
  ],
  finalMap: [
    {
      path: '/final-map',
      exact: true,
      name: 'Final-Map',
      component: FinalMapView,
    },
  ],
  profile: [
    {
      path: '/profile',
      exact: true,
      name: 'Profile',
      component: ProfileView,
    },
    {
      path: '/profile/management',
      exact: true,
      name: 'Profile-management',
      component: ProfileManagementView,
    },
  ],
  share: [
    {
      path: '/share/v/:id/web',
      // exact: true,
      name: 'shareView',
      component: FinalMapView,
    },
    // keeping the next path to keep the old links working... 
    {
      path: '/share/:id/web',
      // exact: true,
      name: 'shareView',
      component: FinalMapView,
    },
  ],
};

export default routes;
